
export function yesNo(language) {
    if(language === "es"){
        return ["sí","no"]
    }
    return ["yes","no"];
}

export function insuranceType(language){
    
    if(language === "es"){
        return [
            "Privado",
            "Medicare",
            "Medicaid",
            "Tricare",
        ]
    }
    return [
        "Private",
        "Medicare",
        "Medicaid",
        "Tricare",
    ]
}

export function gender(language){
    if(language === "es"){
        return ["Hombre","Mujer","Mujer transgénero Female","Hombre transgénero","Variante de género/no conforme","Prefiere no responder"]
    }
    return ["Male","Female","Transgender Female","Transgender Male","Gender Variant/Non-Conforming","Prefer Not to Answer"]
}
export function timeZone(){
    return [
        {
            name: "(GMT-10:00) Hawaii Time",
            value: "Pacific/Honolulu"
        },
        {
            name: "(GMT-9:00) Alaska Time",
            value: "America/Anchorage"
        },
        {
            name: "America/Los_Angeles",
            value: "(GMT-8:00) Pacific Time"
        },
        {
            name: "America/Denver",
            value: "(GMT-7:00) Mountain Time - Denver"
        },
        {
            name: "America/Phoenix",
            value: "(GMT-7:00) Arizona Time"
        },
        {
            name: "America/Chicago",
            value: "(GMT-6:00) Central Time"
        },
        {
            name: "America/New_York",
            value: "(GMT-5:00) Eastern Time"
        },
    ]
}
export function hearGSF(language){
    if(language === "es"){
        return [
            {
                name: "Referencia de amigos/familiares",
                value: "Friend/Family Referral"
            },
            {
                name: "Referencia del médico",
                value: "Doctor Referral"
            },
            {
                name: "Búsqueda en Google",
                value: "Google Search"
            },
            {
                name: "Las redes sociales",
                value: "Social Media"
            },
            {
                name: "Grupo de apoyo",
                value: "Support Group"
            },
            {
                name: "Radio",
                value: "Radio"
            },
            {
                name: "Otro",
                value: "Other"
            },
        ]
    }
    return [
        {
            name: "Friend/Family Referral",
            value: "Friend/Family Referral"
        },
        {
            name: "Doctor Referral",
            value: "Doctor Referral"
        },
        {
            name: "Google Search",
            value: "Google Search"
        },
        {
            name: "Social Media",
            value: "Social Media"
        },
        {
            name: "Support Group",
            value: "Support Group"
        },
        {
            name: "Radio",
            value: "Radio"
        },
        {
            name: "Other",
            value: "Other"
        },
    ]

}
export function reasonList(language){
    if(language === "es"){
        return [{
            name: "Historia personal o familiar de cáncer",
            value: "1"
        },
        {
            name: "Historia personal o familiar de enfermedades cardiacas",
            value: "2"
        },
        {
            name: "Historia personal o familiar de una enfermedad neurológica o neuromuscular",
            value: "3"
        },
        {
            name: "Embarazo actual o futuro",
            value: "4"
        },
        {
            name: "Revisar los resultados de las pruebas genéticas",
            value: "5"
        },
        {
            name: "Otros (especifique)",
            value: "6"
        }]
    }
    return [{
        name: "Personal or family history of cancer",
        value: "1"
    },
    {
        name: "Personal or family history of heart conditions",
        value: "2"
    },
    {
        name: "Personal or family history of a neurological or neuromuscular condition",
        value: "3"
    },
    {
        name: "Current or future pregnancy",
        value: "4"
    },
    {
        name: "Review genetic test results",
        value: "5"
    },
    {
        name: "Other (please specify)",
        value: "6"
    }]
}
export function stateList (){
    return [
        {
            "name": "Alabama",
            "abbreviation": "AL",
            "stateID" : 4570944,
            "insuraceID" : 19793470,
        },
        {
            "name": "Alaska",
            "abbreviation": "AK",
            "stateID" : 4570896,
            "insuraceID" : 19793458,
        },
        {
            "name": "Arizona",
            "abbreviation": "AZ",
            "stateID" : 4570932,
            "insuraceID" : 19793466,
        },
        {
            "name": "Arkansas",
            "abbreviation": "AR",
            "stateID" : 4570935,
            "insuraceID" : 19793468,
        },
        {
            "name": "California",
            "abbreviation": "CA",
            "stateID" : 4570953,
            "insuraceID" : 19793474,
        },
        {
            "name": "Colorado",
            "abbreviation": "CO",
            "stateID" : 4938899,
            "insuraceID" : 19793477,
        },
        {
            "name": "Connecticut",
            "abbreviation": "CT",
            "stateID" : 4570965,
            "insuraceID" : 19793479,
        },
        {
            "name": "Delaware",
            "abbreviation": "DE",
            "stateID" : 4570968,
            "insuraceID" : 19793485,
        },
        {
            "name": "District Of Columbia",
            "abbreviation": "DC",
            "stateID" : 4938812,
            "insuraceID" : 19793483,
        },
        {
            "name": "Florida",
            "abbreviation": "FL",
            "stateID" : 4570971,
            "insuraceID" : 19793486,
        },
        {
            "name": "Georgia",
            "abbreviation": "GA",
            "stateID" : 4571016,
            "insuraceID" : 19793487,
        },
        {
            "name": "Hawaii",
            "abbreviation": "HI",
            "stateID" : 4571019,
            "insuraceID" : 19793488,
        },
        {
            "name": "Idaho",
            "abbreviation": "ID",
            "stateID" : 4577301,
            "insuraceID" : 19793499,
        },
        {
            "name": "Illinois",
            "abbreviation": "IL",
            "stateID" : 4571028,
            "insuraceID" : 19793490,
        },
        {
            "name": "Indiana",
            "abbreviation": "IN",
            "stateID" : 4577289,
            "insuraceID" : 19793496,
        },
        {
            "name": "Iowa",
            "abbreviation": "IA",
            "stateID" : 4571034,
            "insuraceID" : 19793493,
        },
        {
            "name": "Kansas",
            "abbreviation": "KS",
            "stateID" : 4577319,
            "insuraceID" : 19793500,
        },
        {
            "name": "Kentucky",
            "abbreviation": "KY",
            "stateID" : 0,
            "insuraceID" : 0,
        },
        {
            "name": "Louisiana",
            "abbreviation": "LA",
            "stateID" : 4577337,
            "insuraceID" : 19793502,
        },
        {
            "name": "Maine",
            "abbreviation": "ME",
            "stateID" : 4577343,
            "insuraceID" : 19793506,
        },
        {
            "name": "Maryland",
            "abbreviation": "MD",
            "stateID" : 4577349,
            "insuraceID" : 19793509,
        },
        {
            "name": "Massachusetts",
            "abbreviation": "MA",
            "stateID" : 5794116,
            "insuraceID" : 19793416,
        },
        {
            "name": "Michigan",
            "abbreviation": "MI",
            "stateID" : 4577361,
            "insuraceID" : 19793511,
        },
        {
            "name": "Minnesota",
            "abbreviation": "MN",
            "stateID" : 4577367,
            "insuraceID" : 19793515,
        },
        {
            "name": "Mississippi",
            "abbreviation": "MS",
            "stateID" : 4577373,
            "insuraceID" : 19793517,
        },
        {
            "name": "Missouri",
            "abbreviation": "MO",
            "stateID" : 4577376,
            "insuraceID" : 19793519,
        },
        {
            "name": "Montana",
            "abbreviation": "MT",
            "stateID" : 4577379,
            "insuraceID" : 19793523,
        },
        {
            "name": "Nebraska",
            "abbreviation": "NE",
            "stateID" : 4577412,
            "insuraceID" : 19793525,
        },
        {
            "name": "Nevada",
            "abbreviation": "NV",
            "stateID" : 4577415,
            "insuraceID" : 19793528,
        },
        {
            "name": "New Hampshire",
            "abbreviation": "NH",
            "stateID" : 0,
            "insuraceID" : 0,
        },
        {
            "name": "New Jersey",
            "abbreviation": "NJ",
            "stateID" : 0,
            "insuraceID" : 0,
        },
        {
            "name": "New Mexico",
            "abbreviation": "NM",
            "stateID" : 4971623,
            "insuraceID" : 19793532,
        },
        {
            "name": "New York",
            "abbreviation": "NY",
            "stateID" : 4577427,
            "insuraceID" : 19793534,
        },
        {
            "name": "North Carolina",
            "abbreviation": "NC",
            "stateID" : 4577433,
            "insuraceID" : 19793535,
        },
        {
            "name": "North Dakota",
            "abbreviation": "ND",
            "stateID" : 4577442,
            "insuraceID" : 19793538,
        },
        {
            "name": "Ohio",
            "abbreviation": "OH",
            "stateID" : 4577445,
            "insuraceID" : 19793542,
        },
        {
            "name": "Oklahoma",
            "abbreviation": "OK",
            "stateID" : 4971305,
            "insuraceID" : 19793540,
        },
        {
            "name": "Oregon",
            "abbreviation": "OR",
            "stateID" : 4577448,
            "insuraceID" : 19793544,
        },
        {
            "name": "Pennsylvania",
            "abbreviation": "PA",
            "stateID" : 4577454,
            "insuraceID" : 19793547,
        },
        {
            "name": "Rhode Island",
            "abbreviation": "RI",
            "stateID" : 4577460,
            "insuraceID" : 19793551,
        },
        {
            "name": "Puerto Rico",
            "abbreviation": "PR",
            "stateID" : 48373551,
            "insuraceID" : 48373578,
        },
        {
            "name": "South Carolina",
            "abbreviation": "SC",
            "stateID" : 4577463,
            "insuraceID" : 19793554,
        },
        {
            "name": "South Dakota",
            "abbreviation": "SD",
            "stateID" : 4577469,
            "insuraceID" : 19793559,
        },
        {
            "name": "Tennessee",
            "abbreviation": "TN",
            "stateID" : 4577472,
            "insuraceID" : 19793562,
        },
        {
            "name": "Texas",
            "abbreviation": "TX",
            "stateID" : 4577475,
            "insuraceID" : 19793564,
        },
        {
            "name": "Utah",
            "abbreviation": "UT",
            "stateID" : 4971659,
            "insuraceID" : 19793567,
        },
        {
            "name": "Vermont",
            "abbreviation": "VT",
            "stateID" : 4577490,
            "insuraceID" : 19793568,
        },
        {
            "name": "Virginia",
            "abbreviation": "VA",
            "stateID" : 5853978,
            "insuraceID" : 19793422,
        },
        {
            "name": "Washington",
            "abbreviation": "WA",
            "stateID" : 4286568,
            "insuraceID" : 19792445,
        },
        {
            "name": "West Virginia",
            "abbreviation": "WV",
            "stateID" : 4577838,
            "insuraceID" : 19793572,
        },
        {
            "name": "Wisconsin",
            "abbreviation": "WI",
            "stateID" : 4577835,
            "insuraceID" : 19793570,
        },
        {
            "name": "Wyoming",
            "abbreviation": "WY",
            "stateID" : 4577847,
            "insuraceID" : 19793574,
        }
    ]
} 